import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useRemoveMembersFromGroups() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({ userUuids, groupUuids }: { userUuids: string[]; groupUuids: string[] }) => {
      await api.del('group/remove-members-from-groups', {
        members: userUuids,
        groups: groupUuids,
      })

      await Promise.all([invalidate.users(), invalidate.groups()])
    },
  })
}
